'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenteredLayout = exports.DefaultLayout = exports.PlainLayout = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n'], ['\n  width: 100%;\n  height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: ', ';\n'], ['\n  padding: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Base layout component —
// fits an entire viewport
var PlainLayout = _styledComponents2.default.div(_templateObject);

var DefaultLayout = PlainLayout.extend(_templateObject2, function (props) {
  return props.theme.slide.layoutPadding;
});

// A slide layout centered both
// vertically and horizontally
var CenteredLayout = DefaultLayout.extend(_templateObject3);

exports.PlainLayout = PlainLayout;
exports.DefaultLayout = DefaultLayout;
exports.CenteredLayout = CenteredLayout;